// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YsAB","left":"styles_left__RmdjB","desktopActions":"styles_desktopActions__3cBJd","title":"styles_title__pQ0iE"};